// ============================================================================
// JARVISTRAVEL - RECEIPT SCAN STORAGE KEY
// The one place that owns the localStorage key receipt scans persist under, so
// the JarvisTab that reads/writes them and the demo-data purge that clears them
// build the same key (JAR-1992). The key was an inline string in three places
// in JarvisTab; a purge that duplicated it would drift the day one changed.
// ============================================================================

const KEY_PREFIX = 'jarvis_scans_';

/** localStorage key the receipt scans for a trip are stored under. */
export const scanStoreKey = (tripId: string): string => `${KEY_PREFIX}${tripId}`;

/** Remove the stored receipt scans for one trip. Best-effort — storage can be
 *  disabled or blocked, and clearing demo data must not throw. */
export function clearStoredScans(tripId: string): void {
  try {
    localStorage.removeItem(scanStoreKey(tripId));
  } catch {
    /* storage unavailable — nothing to clear */
  }
}
